import React, { useState, useEffect } from "react";
import axios from "axios";
import StatCard from "./StatCard";

const AdminDashboard = () => {
  const [stats, setStats] = useState({
    totalUsers: 0,
    premiumUsers: 0,
    supportTickets: 0,
    revenue: "$0",
  });
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("jwtToken");
        setLoading(true);

        // Try to fetch real data (adjust endpoint as needed)
        try {
          const statsRes = await axios.get(
            `${process.env.REACT_APP_API_URL}/admin-stats`,
            { headers: { Authorization: `Bearer ${token}` } },
          );
          setStats(statsRes.data.data);
        } catch (e) {
          // Fallback to demo data
          console.log("Using demo stats");
        }

        // Fetch recent support messages
        try {
          const messagesRes = await axios.get(
            `${process.env.REACT_APP_API_URL}/admin_support_messages?page=1&perPage=5`,
            { headers: { Authorization: `Bearer ${token}` } },
          );
          setMessages(messagesRes.data.data || []);
        } catch (e) {
          console.log("Could not fetch messages");
        }
      } catch (error) {
        console.error("Failed to fetch dashboard data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      {/* Stats Grid */}
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">Dashboard</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <StatCard
            title="Total Users"
            value={stats.totalUsers || "2,847"}
            change="↑ 12% from last month"
            changeColor="success"
            icon="👥"
          />
          <StatCard
            title="Premium Users"
            value={stats.premiumUsers || "1,263"}
            change="↑ 8% from last month"
            changeColor="success"
            icon="⭐"
          />
          {/* <StatCard
            title="Support Tickets"
            value={stats.supportTickets || "43"}
            change="↓ 5 resolved today"
            changeColor="warning"
            icon="💬"
          />
          <StatCard
            title="Revenue"
            value={stats.revenue || "$12.4K"}
            change="↑ 23% from last month"
            changeColor="success"
            icon="💰"
          /> */}
        </div>
      </div>

      {/* Recent Messages Table */}
      <div className="bg-white rounded-lg shadow-md p-6">
        <h3 className="text-lg font-bold text-gray-900 mb-4 bg-white">
          Recent Support Messages
        </h3>

        {loading ? (
          <div className="text-center py-8">
            <p className="text-gray-500">Loading...</p>
          </div>
        ) : messages.length === 0 ? (
          <div className="text-center py-8">
            <p className="text-gray-500">No messages found</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-gray-200 bg-gray-50">
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600">
                    Email
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600">
                    Subject
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600">
                    Status
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600">
                    Date
                  </th>
                </tr>
              </thead>
              <tbody>
                {messages.map((msg, idx) => (
                  <tr
                    key={msg.message_id || idx}
                    className="border-b border-gray-200 hover:bg-gray-50"
                  >
                    <td className="px-4 py-3 text-sm text-gray-700">
                      {msg.email}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-700">
                      {msg.subject}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      <span
                        className={`px-2 py-1 rounded-md text-xs font-medium ${msg.is_resolved
                            ? "bg-green-100 text-green-700"
                            : "bg-red-100 text-red-700"
                          }`}
                      >
                        {msg.is_resolved ? "Resolved" : "Pending"}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-600">
                      {new Date(msg.created_at).toLocaleDateString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <button className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm font-medium">
          View All →
        </button>
      </div>
    </div>
  );
};

export default AdminDashboard;
